<template>
  <div class="product">
    <div class="return-link mt-3 ml-3">
      <a href="/store" class="back">
        <i class="fa fa-arrow-left"></i> Return to store
      </a>
    </div>
    <Slider :images="images" class="mt-3 product-slider"></Slider>
    <Details :productDetails="productDetails"></Details>
  </div>
</template>

<script>
import axios from "axios";
import Slider from "@/components/product/Slider";
import Details from "@/components/product/Details";

export default {
  name: 'Product',
  data() {
    return {
      images: [],
      productDetails: undefined
    }
  },
  components: {
    Slider,
    Details
  },
  mounted() {
    const parts = window.location.pathname.split("/");
    const slug = parts.pop() || parts.pop();
    this.getProductSlug(slug);
  },
  methods: {
    getProductSlug(slug) {
      axios.get(`/product/${slug}`).then((response) => {
        this.productDetails = response.data.product;
        this.images = [response.data.product.image, ...response.data.product.images];
      });
    },
  }
}
</script>

<style lang="sass" scoped>
.back
  text-transform: uppercase
  color: $dutche-primary-violet
  text-decoration: none
  font-weight: bold
</style>
<style>
@media (max-width: 991px) {
  .image-slider-component .w-100 {
    height: 500px;
    object-fit: contain;
  }
}
@media (max-width: 767px) {
  .image-slider-component .w-100 {
    height: 400px;
    object-fit: contain;
  }
}
</style>
